import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { appRedirect } from "../redirects/appRedirect";
import { appsConfig } from "../redirects/appsConfig";

export default function AppRedirectPage() {
  const { appSlug } = useParams();

  useEffect(() => {
    const app = appsConfig[appSlug];

    if (app) {
      appRedirect(app);
    } else {
      window.location.href = "https://ulagatamizhar.net";
    }
  }, [appSlug]);

  return <p>Redirecting…</p>;
}
